<!-- Overlay -->
<div *ngIf="isMobileMenuOpen()" class="md:hidden backdrop-blur-sm fixed inset-0 bg-black bg-opacity-50 z-30"
  (click)="closeMobileMenu()">
</div>

<!-- Sidenav -->
<nav [class]="sidenavClasses()" class="md:hidden bg-[#212529]">
  <div class="p-6">
    <div (click)="navigateHome()" class="flex items-center space-x-2 cursor-pointer mr-5 mb-4 min-w-fit">
      <p class="text-white text-2xl md:text-4xl font-extrabold tracking-tight z-30">Recruit <span
          class="text-blue-400">AI</span></p>
    </div>
    <div class="space-y-2">
      @for(page of filteredRoutes(); track page) {
      <button (click)="setCurrentPage(page.link)" class="nav-item">
        {{ page.title | titlecase }}
      </button>
      }
    </div>
  </div>
</nav>

<!-- Header Content -->
<div
  class="relative {{route().includes('/review')?'!bg-[#212529] z-50':!isLoggedIn()?'!absolute md:!bg-transparent md:!p-16':'!bg-[#212529]'}} px-2 md:px-4 py-1 md:py-3">

  <!-- Left: Brand/Logo -->
  <div class="w-full flex items-center h-16 md:h-12 px-2">

    @if(isLoggedIn()) {
    <button class="md:hidden mr-2 text-white rounded-lg" (click)="toggleMobileMenu()">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
      </svg>
    </button>
    }

    <div (click)="navigateHome()" class="flex items-center space-x-2 cursor-pointer mr-5 min-w-fit">
      <img src="RA-icon.png" alt="app logo" class="w-10 h-10">
      <p class="hidden sm:block text-white text-2xl md:text-4xl font-extrabold tracking-tight z-30">Recruit <span
          class="text-blue-400">AI</span></p>
    </div>

    @if(isLoggedIn()) {
    <div class="flex items-center gap-1 md:gap-6 w-full">
      <nav class="hidden md:flex items-center gap-1 md:gap-6 mr-auto">
        @for (tab of filteredRoutes(); track tab; let i = $index;) {
        <a [routerLink]="tab.link" routerLinkActive="text-blue-400 border-b-2 border-blue-400"
          [routerLinkActiveOptions]="{exact: true}"
          class="text-lg font-medium text-gray-400 hover:text-white transition-colors duration-200 py-1">
          {{ tab.title }}
        </a>
        }
      </nav>

      <input #businessIconInput type="file" accept="image/png,image/jpeg,image/jpg,image/webp,image/svg+xml"
        class="hidden" (change)="onBusinessIconSelected($event)">

      <button type="button" (click)="triggerBusinessIconPicker()" [disabled]="isUploadingBusinessIcon()"
        aria-label="View or update business icon" matTooltip="Update icon"
        class="ml-auto shrink-0 flex items-center gap-2 text-slate-200 font-medium rounded-full shadow-inner text-sm hover:cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed">
        <span
          class="relative w-10 h-10 md:w-8 md:h-8 rounded-full bg-slate-800/80 flex items-center justify-center">
          @if(isUploadingBusinessIcon()) {
          <mat-spinner diameter="18"></mat-spinner>
          } @else if(showBusinessIconImage()) {
          <img [src]="businessIconUrl()!" alt="Business icon" class="w-full h-full object-cover"
            (error)="onBusinessIconImageError()">
          } @else {
          <mat-icon class="!text-base text-slate-200">business</mat-icon>
          }
          <span
            class="pointer-events-none absolute -right-0.5 -bottom-0.5 w-4 h-4 rounded-full bg-blue-500 text-white flex items-center justify-center border border-[#212529]">
            <mat-icon class="!text-[12px] !w-3 !h-3 !leading-3">add</mat-icon>
          </span>
        </span>
        <span class="hidden md:inline whitespace-nowrap">{{ userState().businessName}}</span>
      </button>

      <div [matMenuTriggerFor]="creditsMenu" matRipple
        class="shrink-0 flex items-center justify-center gap-1 text-slate-200 font-medium px-2 md:px-4 py-1 md:py-2 bg-slate-700/60 rounded-full shadow-inner text-sm relative hover:cursor-pointer">
        <mat-icon class="text-amber-300 text-lg">monetization_on</mat-icon>
        <span class="whitespace-nowrap">
          <span class="font-bold">{{availableCreds()}}</span> <span class="hidden sm:inline"> Credits</span>
        </span>

        <!-- Dropdown trigger -->
        <mat-icon class="text-slate-200">expand_more</mat-icon>
      </div>

      <!-- Dropdown Menu -->
      <mat-menu #creditsMenu="matMenu">
        <button mat-menu-item (click)="openModal('buy')">
          <mat-icon>add_circle</mat-icon>
          <span>Buy Credits</span>
        </button>
        <button mat-menu-item (click)="openModal('billing')">
          <mat-icon>history</mat-icon>
          <span>Transaction History</span>
        </button>
      </mat-menu>

      <div (click)="logout()"
        class="shrink-0 flex items-center justify-center gap-1 text-slate-200 font-medium px-2 md:px-4 py-1 md:py-2 bg-red-500 rounded-full shadow-inner text-sm relative hover:cursor-pointer">
        @if(loading()) {
        <mat-spinner diameter="20" color="accent"></mat-spinner>
        } @else {
        <span class="hidden md:block">Logout</span>
        <mat-icon class="text-md">logout</mat-icon>
        }
      </div>
    </div>
    }
  </div>

</div>

<mat-drawer-container autosize>
  @if(isLoggedIn()) {
  <mat-drawer [mode]="'over'" #drawer class="md:min-w-[800px]">
    <div class="p-4 md:p-6">
      <!-- Back button row -->
      <div class="mb-4 sticky top-2 z-[999]">
        <button mat-icon-button (click)="drawer.close()"
          class="!text-white !bg-[#212529] hover:!bg-[#2c3238] transition-colors !flex !items-center !justify-center">
          <mat-icon>arrow_back</mat-icon>
        </button>
      </div>
      <app-billing [tab]="sidenavType()"></app-billing>
    </div>
  </mat-drawer>
  }

  <div class="h-full {{isLoggedIn()?'':'min-h-screen'}}">
    <router-outlet />
  </div>
</mat-drawer-container>
